import { useMemo } from 'react';
import { IImage } from '.';

export const useImageRatios = (desktopImages: IImage[], mobileImages: IImage[]) => ({
  desktopContainerStyle: useMemo(
    () => ({
      paddingBottom: `calc(${desktopImages[0].height}/${desktopImages[0].width}*100%)`,
    }),
    [desktopImages],
  ),

  mobileContainerStyle: useMemo(
    () => ({
      paddingBottom: `calc(${mobileImages[0].height}/${mobileImages[0].width}*100%)`,
    }),
    [mobileImages],
  ),
});
